import { extractFormInputs } from '../../data-access/formInputs';
import type { FormState } from './ApplicationForm.types';

const isFormState = (value: unknown): value is FormState =>
  typeof value === 'object' && value !== null && typeof (value as FormState).success === 'boolean';

type PostApplicationParams = {
  customerCompanyNumber: string;
  postOfferId: string;
  locale: string;
  formData: FormData;
};

/**
 * Schickt die Bewerbung an /api/applications. Wirft, wenn keine Antwort im FormState-Format kommt
 * (Netzwerkfehler, 502 vom Load Balancer, HTML-Fehlerseite); das Formular faengt das ab.
 */
export const postApplication = async ({
  customerCompanyNumber,
  postOfferId,
  locale,
  formData,
}: PostApplicationParams): Promise<FormState> => {
  const query = new URLSearchParams({ customerCompanyNumber, postOfferId, locale });
  const response = await fetch(`/api/applications?${query}`, { method: 'POST', body: formData });

  const body: unknown = await response.json().catch(() => undefined);
  if (!isFormState(body)) {
    throw new Error(`Application request failed with status ${response.status}`);
  }

  return { ...body, inputs: body.inputs ?? (body.success ? undefined : extractFormInputs(formData)) };
};
